import * as React from 'react';
import {TextArea} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

export const Primary = () => (
  <TextArea
    label="Biography"
    placeholder="Acme Inc was founded in…"
    defaultValue={EXAMPLE_TEXT}
  />
);
